import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "m-pageCW-map-modal" }
const _hoisted_2 = { class: "m-pageCW-map-modal__preview" }
const _hoisted_3 = { class: "m-pageCW-map-modal__preview-head" }
const _hoisted_4 = { class: "count" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.92893 17.8284C6.83418 21.7337 13.1658 21.7337 17.0711 17.8284C20.9763 13.9232 20.9763 7.59153 17.0711 3.68629C13.1658 -0.218956 6.83418 -0.218956 2.92893 3.68629C-0.976311 7.59153 -0.97631 13.9232 2.92893 17.8284ZM14.0406 6.71674C13.4827 6.15885 12.5782 6.15885 12.0203 6.71674L10 8.73705L7.97969 6.71674C7.4218 6.15885 6.51728 6.15885 5.95939 6.71674C5.4015 7.27464 5.4015 8.17916 5.95939 8.73705L7.97969 10.7574L5.95939 12.7777C5.4015 13.3356 5.4015 14.2401 5.95939 14.798C6.51728 15.3559 7.4218 15.3559 7.97969 14.798L10 12.7777L12.0203 14.798C12.5782 15.3559 13.4827 15.3559 14.0406 14.798C14.5985 14.2401 14.5985 13.3356 14.0406 12.7777L12.0203 10.7574L14.0406 8.73705C14.5985 8.17916 14.5985 7.27464 14.0406 6.71674Z",
  fill: "none",
  "fill-opacity": "0.5"
}, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "m-pageCW-map-modal__preview-content js-swiper-detail-work" }
const _hoisted_9 = { class: "swiper-wrapper" }
const _hoisted_10 = { class: "swiper-slide" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "m-pageCW-map-modal__preview-content-buttons" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next" }),
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev" })
], -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemDetailWork = _resolveComponent("ItemDetailWork")!

  return (_openBlock(), _createElementBlock("div", {
    class: "m-pageCW-map-modal-container",
    style: _normalizeStyle(_ctx.isFullScreenMap ? 'align-items: center' : '')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getWorkCount()), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.pluralWord(_ctx.getWorkCount(), ['Работа', 'Работы', 'Работ'])) + " " + _toDisplayString(_ctx.pluralWord(_ctx.getWorkCount(), ['найдена', 'найдено', 'найдено'])), 1 /* TEXT */),
          (_openBlock(), _createElementBlock("svg", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showSelectedWork', false))),
            width: "20",
            height: "21",
            viewBox: "0 0 20 21",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_7))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getListAllSelectedWorks(), (work) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_ItemDetailWork, { work: work }, null, 8 /* PROPS */, ["work"])
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _hoisted_11,
          _hoisted_12
        ])
      ])
    ])
  ], 4 /* STYLE */))
}